const FR_REGISTRATION_NUMBER_EXAMPLE = '29492700688985';
const FR_REGISTRATION_NUMBER_TYPE = 'SIRET';

export const REGISTRATION_NUMBER_EXAMPLES_BY_COUNTRIES = {
    AD: {
        example: 'A-123456-A',
        type: 'NRT',
    }, // Andorra
    AE: {
        example: '123456789012345',
        type: 'TLN/TRN/DIFC License number/BL Local No',
    }, // United Arab Emirates
    AR: {
        example: '12-34567890-1',
        type: 'CUIT/DNI',
    }, // Argentina
    AT: {
        example: 'FN123456A',
        type: 'Firmenbuchnummer/Steuernummer',
    }, // Austria
    AU: {
        example: '123 456 789',
        type: 'ACN/ABN',
    }, // Australia
    BE: {
        example: '1234567890',
        type: 'TIN/CBE',
    }, // Belgium
    BL: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - St. Barthélemy
    BR: {
        example: '123.456.789-01',
        type: 'CPF/CNPJ',
    }, // Brazil
    BU: {
        example: '1234567890',
        type: 'UCN/UIC',
    }, // Bulgaria
    BY: {
        example: '123456789',
        type: 'PN/UNP',
    }, // Belarus
    CA: {
        example: '123456789',
        type: 'BN/DUNS/NEQ',
    }, // Canada
    CH: {
        example: 'CHE-123.456.789',
        type: 'CHRN',
    }, // Switzerland
    CO: {
        example: '123.456.789-0',
        type: 'NIT',
    }, // Colombia
    CL: {
        example: '12345678-9',
        type: 'TIN',
    }, // Chile
    CY: {
        example: 'CY-12345678A',
        type: 'TIN/CRN',
    }, // Cyprus
    CZ: {
        example: 'CZ123456/1234',
        type: 'DIC',
    }, // Czech Republic
    DE: {
        example: 'HRA123546',
        type: 'Registernummer/Identifikationsnummer/Steuernummer/VAT/VR/PR',
    }, // Germany
    DK: {
        example: '12345678',
        type: 'CPR/CVR/SE',
    }, // Denmark
    EE: {
        example: '12345678901',
        type: 'IK/RN',
    }, // Estonia
    EG: {
        example: '123-456-789',
        type: 'TN',
    }, // Egypt
    ES: {
        example: '54362315K',
        type: 'CIF/NIE/NIF',
    }, // Spain
    FI: {
        example: '1234567-8',
        type: 'Business ID',
    }, // Finland
    FR: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France
    GB: {
        example: '1234567890',
        type: 'NINO/UTR/TRN',
    }, // Great-Britain
    GE: {
        example: '123456789',
        type: 'TIN,Personal Number',
    }, // Georgia
    GF: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - French Guiana
    GG: {
        example: 'CMP12345',
        type: 'Company number',
    }, // Guernsey
    GP: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - Guadeloupe
    GR: {
        example: '123456789',
        type: 'TIN',
    }, // Greece
    HR: {
        example: 'HR12345678901',
        type: 'OIB',
    }, // Croatia
    HU: {
        example: '0123456789',
        type: 'IN/EN',
    }, // Hungary
    IE: {
        example: '0123456A',
        type: 'TIN',
    }, // Ireland
    IM: {
        example: '123456C',
        type: 'CRN',
    }, // Isle of Man
    IN: {
        example: 'AAAAA1234A',
        type: 'PAN/CIN',
    }, // India
    IS: {
        example: 'IS123456',
        type: 'KN/VSK',
    }, // Iceland
    IT: {
        example: 'AAAAAA12A34A567A',
        type: 'Codice Fiscale / REA',
    }, // Italy
    KW: {
        example: '012345678901',
        type: 'CIN',
    }, // Kuwait
    LI: {
        example: '0123',
        type: 'PEID',
    }, // Liechstenstein
    LT: {
        example: '012345678',
        type: 'AK/PVM',
    }, // Lithuania
    LU: {
        example: '01234567890',
        type: 'IN',
    }, // Luxembourg
    LV: {
        example: '010101-11111',
        type: 'TIN',
    }, // Latvia
    MA: {
        example: '0123456',
        type: 'TIN',
    }, // Morocco
    MD: {
        example: '1234567890123',
        type: 'IDNO',
    }, // Moldova
    MF: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - St. Martin
    MT: {
        example: '1234567A',
        type: 'IN/EN/TIN',
    }, // Malta
    MQ: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - Martinique
    NC: {
        example: '1234567',
        type: 'RID7',
    }, // New Caledonia
    NL: {
        example: '12345678',
        type: 'KVK/TIN',
    }, // Netherlands
    NO: {
        example: '123456789',
        type: 'NIN / ORGNR',
    }, // Norway
    NZ: {
        example: '123-456-789',
        type: 'IRD/NZBN',
    }, // New Zealand
    OM: {
        example: '0123456',
        type: 'TIN/TRN',
    }, // Oman
    PF: {
        example: 'A12345',
        type: 'RTE/Siret',
    }, // French Polynesia
    PL: {
        example: '12345678901',
        type: 'PESEL/REGON',
    }, // Poland
    PM: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - St. Pierre and Miquelon
    PT: {
        example: '123456789',
        type: 'NIF',
    }, // Portugal
    QA: {
        example: '1234567890',
        type: 'TIN/QFC',
    }, // Qatar
    RE: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - Réunion
    RO: {
        example: '1234567890123',
        type: 'CNP/CUI',
    }, // Romania
    SA: {
        example: '123456789012345',
        type: 'TIN',
    }, // Saudi Arabia
    SE: {
        example: '1234567890',
        type: 'TIN',
    }, // Sweden
    SG: {
        example: '12345678A',
        type: 'NRIC/FIN/UEN',
    }, // Singapore
    SI: {
        example: '01234567',
        type: 'TIN/REG',
    }, // Slovenia
    SK: {
        example: '012345678',
        type: 'RC/EN/ICO',
    }, // Slovakia
    TF: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - French Southern Territories
    TH: {
        example: '0123456789012',
        type: 'TIN',
    }, // Thailand
    TN: {
        example: '1234567A',
        type: "Numéro d'immatriculation au RNE",
    }, // Tunisia
    TR: {
        example: '12345678901',
        type: 'NIN/VKN',
    }, // Turkey
    UA: {
        example: '1234567890',
        type: 'RNTRC/EDRPOU/ITIN',
    }, // Turkey
    US: {
        example: '12-3456789',
        type: 'EIN/DUNS/FEI',
    }, // United States of America
    WF: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - Wallis & Futuna
    YT: {
        example: FR_REGISTRATION_NUMBER_EXAMPLE,
        type: FR_REGISTRATION_NUMBER_TYPE,
    }, // France - Mayotte
    ZA: {
        example: '1234567890, 1234/123456/12',
        type: 'TRN',
    }, // South Africa
};
